import React from "react";
import { SX, TX } from "../studioTokens";
import { ALERT } from "./billingConst";

/* Small shared pieces for the billing page, kept together so section heads and
   banners look the same everywhere on it. */

export const SectionHead = ({ title, hint, right }) => (
  <div className="flex items-end justify-between gap-4 flex-wrap mb-3.5">
    <div>
      <div className={TX.sectionHeading}>{title}</div>
      {hint && <div className={`${TX.helper} mt-0.5`}>{hint}</div>}
    </div>
    {right}
  </div>
);

/* Full-width alert strip. `actions` renders on the right on wide viewports and
   wraps beneath the copy on narrow ones. */
export const Banner = ({ tone = "info", icon: Icon, title, children, actions }) => {
  const a = ALERT[tone] || ALERT.info;
  return (
    <div className={`flex items-start gap-3.5 rounded-[12px] border px-4 py-3.5 ${a.wrap}`}>
      {Icon && (
        <div className={`w-9 h-9 rounded-[10px] flex items-center justify-center flex-shrink-0 ${a.icon}`}>
          <Icon size={18} />
        </div>
      )}
      <div className={`flex-1 min-w-0 text-[13px] leading-[1.5] ${a.text}`}>
        {title && <div className="font-semibold text-[13.5px]">{title}</div>}
        {children}
      </div>
      {actions && <div className="flex items-center gap-2 flex-shrink-0 flex-wrap">{actions}</div>}
    </div>
  );
};

export const EmptyRow = ({ icon: Icon, children }) => (
  <div className={`${SX.card} py-10 px-6 text-center`}>
    {Icon && <Icon size={22} className="text-[#8A8A90] mx-auto mb-2" />}
    <div className="text-[13px] text-[#52525B]">{children}</div>
  </div>
);
